/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Site_Relation_LabelInputs */

const en_site_relation_label = /** @type {(inputs: Site_Relation_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your relation to this site`)
};

const id_site_relation_label = /** @type {(inputs: Site_Relation_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hubunganmu dengan situs ini`)
};

/**
* | output |
* | --- |
* | "Your relation to this site" |
*
* @param {Site_Relation_LabelInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const site_relation_label = /** @type {((inputs?: Site_Relation_LabelInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Site_Relation_LabelInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_site_relation_label(inputs)
	return en_site_relation_label(inputs)
});